import styled from "@emotion/styled"
import styledNative from "@emotion/native"
import { ReactNode } from "react"

type LinearGradientWrapperProps = {
  children: ReactNode
  end: { x: number; y: number }
  colors?: (string | number)[]
}

export function LinearGradient(props: LinearGradientWrapperProps) {
  const { children, colors = ["#e66465", "#9198e5"], end } = props

  return (
    <Container>
      <Gradient colors={colors} gradientEnd={end.y}>
        <>{children}</>
      </Gradient>
    </Container>
  )
}

const Container = styledNative.View`
  background-color: white;
  flex: 1;
`

const Gradient = styled.div<{ colors: (string | number)[]; gradientEnd: number }>`
  background: ${({ colors, gradientEnd }) =>
    `linear-gradient(${colors[0]}, ${colors[1]} ${gradientEnd * 100}%)`};
  flex-basis: 0px;
  flex-grow: 1;
  flex-shrink: 1;
  align-items: stretch;
  border: 0px solid black;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0px;
  min-height: 0px;
  min-width: 0px;
  padding: 0px;
  position: relative;
  text-decoration: none;
  z-index: 0;
`
